"use client"

import { useEffect, useState } from 'react'
import MiniLicensePlate from './MiniLicensePlate'
import DueBar from "./DueBar"
import { makeIntoDollars } from '../../GlobalFuncs'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"

import ExpandedTicket from './ExpandedTicket'
import Spacer from '../AllPurpose/Spacer'
import { Info, InfoIcon, MapPin, TriangleAlert } from 'lucide-react'
import mapPin from '../../assets/images/mapPin.png'
import Image from 'next/image'

const LeftOpenTicket = ({
  ticket,
  directState,
  directPlate,

  showDetailsDrawer
}) => {

  // for % of due bar filled
  const calculateDueBarValue = () => {

    // e.g
    // 100
    let issueDate = ticket.unixIssueDate
    // 300
    let dueDate = ticket.unixDueDate
    // 200
    let denominator = dueDate - issueDate

    // time, in s, since unix in 1970
    let now = Date.now() / 1000

    let numerator = now - issueDate

    let fraction = numerator / denominator

    // prevents dueBarValue > 1
    let value = fraction < 1 ? fraction : 1
    return value

  }

  const [dueBarValue, setDueBarValue] = useState(0)

  useEffect(() => {
    setDueBarValue(calculateDueBarValue())
  }, [])

  // for due date e.g. 5/12
  const calculateDueDate = () => {

    const rawDate = new Date(ticket.unixDueDate * 1000)

    return new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' }).format(rawDate);

  }

  const dueDate = calculateDueDate()

  let abbreviatedArea = ticket.city === 'New York City' ? 'NYC' : (ticket.city === 'Washington, DC' ? 'DC' : '')


  function daysToYearsLabel(days) {
    const years = Math.floor(days / 365);
    return `${years} year${years !== 1 ? 's' : ''}`;
  }

  function daysAgoVerbiage(days) {

    return days > 365 ? `${daysToYearsLabel(days)} overdue` : `${days} day${days > 1 ? 's' : ''} overdue`

  }


  function formatUnixToDate(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000); // convert seconds to ms
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    return `${mm}/${dd}/${yy}`;
  }

  return (
    <button
      className={` flex flex-col w-[350px] items-start justify-between transition-opacity duration-300 ease-in`}
      onClick={showDetailsDrawer}
    >

      {/* top row */}
      <div className={`flex flex-row items-center h-[37.5px] w-full space-x-[12.5px]`}>

        <p className={`font-tpBold text-[28px] justify-center text-black`}>

          {makeIntoDollars(ticket.potentialPaymentAmount)}

        </p>


        <div className='border-gray-300 rounded-full flex items-center justify-center relative top-[2px]'>

          <div className='relative top-[0px] pr-[7.5px]'>
            <Image
              src={mapPin}
                    alt=""
              width={14}
              height={14}
            />
          </div>

          <p className={`font-tpThin text-[20px] justify-center text-gray-700 relative top-[1.5px] right-[2px]`}>
            {ticket.borough === '' ? 'NYC' : ticket.borough}
          </p>

        </div>

        <Spacer />

      </div>

      <Spacer />

      {/* middle row */}
      <div className="flex flex-row items-center w-full space-x-[6px] h-[35px]">

        <p className={`font-tpThin text-[22px] justify-center text-gray-800 relative truncate`}>

          {ticket.category} ticket

        </p>

        <p className={`font-menlo text-[14px] justify-center text-gray-500 relative top-[2.5px] truncate opacity-80`}>

          #{ticket.ticket}

        </p>

        <Spacer />

      </div>

    </button>
  )
}

export default LeftOpenTicket